import "core-js/modules/es.array.push.js";
import { transformStr3, handleHttp, getformListItemsdata, getformListItemsdatas, insertStr, locationHandle } from "@/utils/utils";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import VueAudio from 'vue-audio';
// import 'vue-audio-player/dist/vueaudioplayer.css'
export default {
  data() {
    return {
      fid: this.$route.query.fid,
      popLeftArr: [{
        name: '简介',
        id: 0
      }, {
        name: '资讯',
        id: 1
      }],
      popLeftIndex: 0,
      linkcontainerflag: false,
      iframeurl: '',
      infoList: [],
      infoitem: '',
      infoitemflag: false,
      infotypeList: [],
      // 文化馆对接数据
      whgForm: {
        redirectform: 'whgmapformId20230630',
        info: {
          formId: 'map_article',
          t: '605b3bf9e2783c8ccb9a3a9b59ebf4d20394b695268c816158f53c2e9a3833f0'
        },
        infotype: {
          formId: '863637',
          t: 'ca55f62c90f5a266475f3d0b1047b477aa5084d3028db91d73d6a5f2391a6610'
        },
        video: {
          formId: 'video',
          t: 'bc2762186b75ab3f75df630c9fc58114'
        }
      },
      videoList: [],
      videoitem: '',
      videoitemflag: false
    };
  },
  components: {
    VueAudio
  },
  watch: {
    '$attrs.detail.banner'(val) {
      if (val) {
        this.swiperEl = new Swiper(this.$refs.swipercontainer, {
          initialSlide: 0,
          slidesPerView: this.isApp ? 1 : 2.3,
          autoplay: true,
          speed: 500,
          spaceBetween: this.isApp ? 0 : 10,
          observeSlideChildren: true,
          observeParents: true,
          observer: true
        });
      }
    },
    '$attrs.detail.audio'(val) {
      if (val && val.length > 0) {
        let isHasaudio = this.popLeftArr.find(item => {
          return item.id === 3;
        });
        if (!isHasaudio) this.popLeftArr.push({
          name: '音频',
          id: 3
        });
      }
    },
    '$attrs.detail.video'(val) {
      if (val && val.length > 0) {
        let isHasvideo = this.popLeftArr.find(item => {
          return item.id === 2;
        });
        if (!isHasvideo) this.popLeftArr.push({
          name: '视频',
          id: 2
        });
      }
    },
    '$attrs.detail.placeName'(val) {
      if (val) {
        // 平谷资讯
        if (this.fid === '10408') this.getInfoList(val);
      }
    },
    '$attrs.detail.otherinfo'(val) {
      if (val) {
        if (val.length > 0) {
          // 鹤山资讯
          if (this.fid === '63095') {
            this.getOtherInfo(val);
            this.getVideo(this.$attrs.detail);
          }
        } else {
          this.popLeftArr = this.popLeftArr.filter(item => {
            return item.id !== 4;
          });
        }
      }
    }
  },
  methods: {
    // 统一换地址
    sethandleHttp(url) {
      return handleHttp(url);
    },
    // 关闭事件
    closePop() {
      this.$emit('closeHandle');
      this.popshowflag = false;
      this.popLeftIndex = 0;
      this.closeinfoItem();
      this.closevideoItem();
    },
    closeinfoItem() {
      this.infoitemflag = false;
      this.infoitem = '';
    },
    closevideoItem() {
      this.videoitemflag = false;
      this.videoitem = '';
    },
    // 弹窗左边点击事件
    popLeftHandle(id) {
      this.popLeftIndex = id;
    },
    // 返回事件
    goback() {
      this.linkcontainerflag = false;
      this.iframeurl = '';
    },
    goLocation(url) {
      locationHandle.call(this, this.$attrs.detail, url);
    },
    // 跳转
    goLink(url) {
      // 若选择打开新窗口处理
      if (this.$attrs.detail.linkTarget !== undefined && this.$attrs.detail.linkTarget === '是') {
        window.open(url);
      } else {
        this.linkcontainerflag = true;
        this.iframeurl = url;
      }
    },
    // 资讯切换
    infoItemHandle(item) {
      this.infoitemflag = true;
      this.infoitem = item.itemformdata;
    },
    getInfoList(val) {
      let _this = this;
      let dataform = {
        deptId: this.fid,
        formId: 637671,
        limit: 50,
        page: 1,
        searchStr: {
          'model': 0,
          'filters': [[{
            'id': 1,
            'alias': '4',
            'compt': 'editinput',
            'express': '===',
            'val': val,
            'range': null
          }]]
        }
      };
      dataform.searchStr = encodeURI(JSON.stringify(dataform.searchStr));
      this.$api.singleadvanceSearch(dataform).then(res => {
        _this.infoList = [];
        if (res.totalRow > 0) {
          res.dataList.forEach(item => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
          });
          _this.infoList = res.dataList;
        }
        _this.popLeftArr = _this.popLeftArr.filter(item => {
          return item.id !== 1;
        });
        if (_this.infoList.length !== 0) {
          _this.popLeftArr.push({
            name: '资讯',
            id: 1
          });
        }
      });
    },
    getOtherInfo(val) {
      let _this = this;
      this.infotypeList = [];
      let infotypesearch = {
        deptId: this.fid,
        formId: this.whgForm.infotype.formId,
        t: this.whgForm.infotype.t,
        page: 1,
        limit: 50
      };
      this.$api.singleadvanceSearchv2(infotypesearch).then(res => {
        if (res.totalRow > 0) {
          // 判断是否有资讯分类
          let dataList = res.dataList.map(item => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            item.itemformdata.image = handleHttp(itemformat.thumb[0].fileUrl);
            _this.$attrs.detail.otherinfo.forEach(elem => {
              if (elem.val === item.itemformdata.name) {
                _this.infotypeList.push(item.itemformdata);
              }
            });
            return item;
          });
        }
      });

      // 获取文章
      this.getInfo(this.$attrs.detail, this.$attrs.detail.otherinfo[this.$attrs.detail.otherinfo.length - 1].val);
    },
    getInfo(detail, val) {
      let _this = this;
      let infosearchStr = {
        deptId: this.fid,
        formId: this.whgForm.info.formId,
        searchStr: {
          'model': 0,
          'filters': [[{
            'alias': 'map',
            'compt': 'selectmultibox',
            'express': 'like',
            'val': [detail.placeName]
          }]]
        },
        t: this.whgForm.info.t,
        page: 1,
        limit: 50
      };
      if (detail.otherinfo.length > 0) {
        infosearchStr.searchStr.filters.push([{
          'alias': 'category',
          'compt': 'selectbox',
          'express': '===',
          'val': [val]
        }]);
        // 判断是否有资讯菜单
        let isHasinfo = _this.popLeftArr.find(item => {
          return item.id === 4;
        });
        if (!isHasinfo) _this.popLeftArr.push({
          name: '文章',
          id: 4
        });
      }
      infosearchStr.searchStr = encodeURI(JSON.stringify(infosearchStr.searchStr));
      this.$api.singleadvanceSearchv2(infosearchStr).then(res => {
        // console.log(res)
        if (res.totalRow > 0) {
          _this.infoList = res.dataList.map(item => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            item.itemformdata.image = handleHttp(itemformat.thumb[0].fileUrl);
            return item;
          });
          // console.log(_this.popLeftArr)
        } else {
          _this.infoList = [];
        }
      });
    },
    getVideo(detail) {
      let _this = this;
      let infosearchStr = {
        deptId: this.fid,
        formId: this.whgForm.video.formId,
        searchStr: {
          'model': 0,
          'filters': [[{
            'alias': 'map',
            'compt': 'selectmultibox',
            'express': 'like',
            'val': [detail.placeName]
          }]]
        },
        t: this.whgForm.video.t,
        page: 1,
        limit: 50
      };
      infosearchStr.searchStr = encodeURI(JSON.stringify(infosearchStr.searchStr));
      this.$api.singleadvanceSearchv2(infosearchStr).then(res => {
        if (res.totalRow > 0) {
          _this.videoList = [];
          // 判断是否有视频菜单
          let isHasvideo = _this.popLeftArr.find(item => {
            return item.id === 5;
          });
          if (!isHasvideo) _this.popLeftArr.push({
            name: '视频',
            id: 5
          });
          _this.videoList = res.dataList.map(item => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            item.itemformdata.image = handleHttp(itemformat.thumb[0].fileUrl);
            if (itemformat.video.length > 0) {
              this.$api.getUrlByObjectId(itemformat.video[0].objectId).then(res => {
                let currenthttp = location.protocol;
                this.$attrs.detail[val + 'url'] = res.http;
              });
            }
            return item;
          });
        } else {
          _this.videoList = [];
          _this.popLeftArr = _this.popLeftArr.filter(item => {
            return item.id !== 5;
          });
        }
      });
    },
    // 资讯分类切换
    infoTypeHandle(item) {
      this.getInfo(this.$attrs.detail, item.name);
    },
    // 视频切换
    videoItemHandle(item) {
      this.videoitemflag = true;
      this.videoitem = this.popLeftIndex === 2 ? item : item.itemformdata;
    }
  }
};